/**************************************************
 * Nombre:       Formulario_Pdfs_Paises
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {FlagOutlined, TitleOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import IngresoSelectFuncion from "../../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {PAISESINDICATIVO} from "../../../Modulo_formularios/Recursos/indicativos";
import Tarjeta_Pais_Seleccionado from "../../Tarjetas/Tarjeta_Pais_Seleccionado";

const Formulario_Pdfs_Paises = ({...props}) => {
    const [seleccionado, setSeleccionado] = useState('');
    const [paises, setPaises] = useState([]);

    const seleccion = (e) => {
        setSeleccionado(e)
    }

    const adicionar = () => {

       // let paises_ = PAISESINDICATIVO.map((it) => it.nameES)

        let index = paises.findIndex((e) => e === seleccionado);
        console.log(index)
        if (index === -1) {

            let desps = paises
            desps.push(seleccionado)
            props.props.setValue('paises', desps)
            setSeleccionado('')
        }

    }

    const quitar = (sel) => {



        let index = paises.findIndex((e) => e === sel);
        if (index > -1) {
            let desps = paises
            desps.splice(index, 1)
            props.props.setValue('paises', desps)
        }

    }


    useEffect(() => {

        setPaises([])
        let deps = props.props.getValues('paises');
        if (deps && deps.length > 0) {
            setPaises(deps)
        }


    }, [props.props.watch('paises')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del Pdf'} dato={'nombre'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={9}>
                    <IngresoSelectFuncion Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                          setDato={seleccion} opciones={[...PAISESINDICATIVO.map((it) => it.nameES),'Todos']}
                    />
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => adicionar()}
                    >Agregar</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {paises.map(it => (
                            <Tarjeta_Pais_Seleccionado item={it} quitar={quitar}/>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pdfs_Paises